import React from "react";
import { Instagram, Phone, MapPin, Mail } from "lucide-react";
import { BRAND, IMAGES } from "../../lib/site";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18" {...props}>
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.05-2.82h-3.11v12.4a2.53 2.53 0 0 1-2.53 2.44 2.53 2.53 0 1 1 .77-4.94V9.7a5.66 5.66 0 0 0-.77-.05A5.66 5.66 0 1 0 15.56 15.3V9.01a7.36 7.36 0 0 0 4.3 1.38V7.28a4.28 4.28 0 0 1-3.26-1.46z" />
  </svg>
);

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Footer = () => {
  return (
    <footer className="relative bg-[#2c1e16] text-[#f9f6f0] overflow-hidden" data-testid="site-footer">
      {/* Massive background word */}
      <div className="pointer-events-none select-none absolute -bottom-4 md:-bottom-10 left-0 right-0 text-center">
        <span className="font-display text-[22vw] leading-none text-[#f9f6f0]/[0.04]">ELEVATION</span>
      </div>

      <div className="relative mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12 pt-20 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={IMAGES.logo} alt="logo" className="h-12 w-12 object-contain" />
              <span className="font-display text-2xl">Braiding Elevation Inc</span>
            </div>
            <p className="mt-6 font-display italic text-2xl md:text-3xl text-[#c96c31] max-w-sm leading-tight">
              {`\u201C${BRAND.slogan}\u201D`}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-[#f9f6f0]/50 mb-5">Visit</p>
            <a
              href="https://maps.google.com/?q=6490+Landover+Rd+Suite+B3"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address"
              className="flex items-start gap-3 font-body text-[#f9f6f0]/85 hover:text-[#c96c31] transition-colors"
            >
              <MapPin size={18} className="mt-0.5 shrink-0" /> {BRAND.address}
            </a>
            <p className="mt-4 font-body text-[#f9f6f0]/60">{BRAND.hours}</p>
          </div>

          <div className="md:col-span-4">
            <p className="font-body text-xs uppercase tracking-[0.25em] text-[#f9f6f0]/50 mb-5">Connect</p>
            <a href={BRAND.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 font-body text-[#f9f6f0]/85 hover:text-[#c96c31] transition-colors">
              <Phone size={18} /> {BRAND.phone}
            </a>
            <a href="mailto:Condese1984@gmail.com" data-testid="footer-email" className="mt-4 flex items-center gap-3 font-body text-[#f9f6f0]/85 hover:text-[#c96c31] transition-colors break-all">
              <Mail size={18} className="shrink-0" /> Condese1984@gmail.com
            </a>
            <div className="mt-6 flex items-center gap-4">
              <a href={BRAND.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="grid place-items-center h-11 w-11 rounded-full border border-[#f9f6f0]/20 hover:bg-[#c96c31] hover:border-[#c96c31] transition-colors">
                <Instagram size={18} />
              </a>
              <a href={BRAND.tiktok} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" aria-label="TikTok" className="grid place-items-center h-11 w-11 rounded-full border border-[#f9f6f0]/20 hover:bg-[#c96c31] hover:border-[#c96c31] transition-colors">
                <TikTokIcon />
              </a>
              <span className="font-body text-sm text-[#f9f6f0]/60">{BRAND.handle}</span>
            </div>
            <button
              data-testid="footer-book-btn"
              onClick={() => scrollTo("book")}
              className="mt-8 rounded-full bg-[#c96c31] px-7 py-3.5 font-body text-sm font-medium uppercase tracking-wider text-[#f9f6f0] hover:bg-[#b35d27] hover:-translate-y-0.5 transition-all duration-300"
            >
              Book Now
            </button>
          </div>
        </div>

        <div className="relative mt-16 pt-8 border-t border-[#f9f6f0]/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-[#f9f6f0]/50">
            © {new Date().getFullYear()} Braiding Elevation Inc. All rights reserved.
          </p>
          <p className="font-body text-xs text-[#f9f6f0]/50 uppercase tracking-widest">Landover, Maryland</p>
        </div>
      </div>
    </footer>
  );
};
